import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M35.978 16.97c.19-6.418-4.86-11.775-11.278-11.965Q24.527 5 24.356 5h-1.727c-6.368 0-11.531 5.163-11.531 11.532q0 .215.008.43l.397 10.619a7 7 0 0 1-1.727 4.871l-2.529 2.89A1 1 0 0 0 8 37h31.185a1 1 0 0 0 .752-1.658l-2.545-2.91a7 7 0 0 1-1.73-4.817zm2.919 14.145 2.546 2.91A3 3 0 0 1 39.185 39H8a3 3 0 0 1-2.258-4.975l2.529-2.89a5 5 0 0 0 1.233-3.48l-.397-10.618q-.01-.253-.01-.505C9.098 9.058 15.158 3 22.63 3h1.726q.201 0 .403.006c7.522.223 13.44 6.501 13.218 14.024l-.315 10.644a5 5 0 0 0 1.235 3.44M18.096 41.408a1 1 0 1 1 1.831-.803 4 4 0 0 0 7.326.012 1 1 0 1 1 1.828.81 6 6 0 0 1-10.985-.019M12.475 29h22.243c1.333 0 1.333 2 0 2H12.475c-1.333 0-1.333-2 0-2",
      clipRule: "evenodd"
    }
  )
);
var SvgNotificationOnOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var NotificationOnOutlined_default = SvgNotificationOnOutlined;

export { NotificationOnOutlined_default as default };
